import React from 'react'
import styled from 'styled-components'
import LabelOnly from './LabelOnly'

export interface KepcoChargeUnitData {
  name: string
  defaultChargeUnit: number
  chargeUnit: {
    fall: { min: number; mid: number; max: number }
    spr: { min: number; mid: number; max: number }
    sum: { min: number; mid: number; max: number }
    win: { min: number; mid: number; max: number }
  }
}

interface KepcoChargeUnitTableProps {
  data: KepcoChargeUnitData
  label?: string
}

const LabelTable = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

const TableWrapper = styled.div`
  padding: 0px 0px 0px 10px;
  overflow-x: auto;
`

const Table = styled.div`
  display: flex;
  flex-direction: column;
  width: max-content;
  border-radius: 4px;
  border: 1px solid transparent;
`

const TableRow = styled.div`
  display: flex;
`

interface TableGrayProps {
  white?: boolean
}

const TableCell = styled.div<TableGrayProps>`
  display: flex;
  width: 122.8px;
  height: 38px;
  padding: 8px 0px 8px 0px;
  border: 0.5px solid #e6e6e6;
  background: ${(props) => (props.white ? '' : '#f4f5f8')};
  font-family: SUIT;
  font-size: 12px;
  font-weight: 500;
  line-height: 15px;
  letter-spacing: 0em;
  align-items: center;
  justify-content: center;
`

export const KepcoChargeUnitTable = ({
  data,
  label,
}: KepcoChargeUnitTableProps) => {
  return (
    <LabelTable>
      {label && <LabelOnly label={label} />}
      <TableWrapper>
        <Table>
          <TableRow>
            <TableCell style={{ borderTopLeftRadius: '4px' }}>
              기본요금
            </TableCell>
            <TableCell>시간대</TableCell>
            <TableCell>봄·가을</TableCell>
            <TableCell>여름</TableCell>
            <TableCell style={{ borderTopRightRadius: '4px' }}>겨울</TableCell>
          </TableRow>
          <TableRow>
            <TableCell style={{ borderBottom: '0.5px solid #F4F5F8' }} />
            <TableCell>경부하</TableCell>
            <TableCell white>{data.chargeUnit.spr.min}</TableCell>
            <TableCell white>{data.chargeUnit.sum.min}</TableCell>
            <TableCell white>{data.chargeUnit.win.min}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell
              style={{
                borderTop: '0.5px solid #F4F5F8',
                borderBottom: '0.5px solid #F4F5F8',
              }}
            >
              {data.defaultChargeUnit}
            </TableCell>
            <TableCell>중간부하</TableCell>
            <TableCell white>{data.chargeUnit.spr.mid}</TableCell>
            <TableCell white>{data.chargeUnit.sum.mid}</TableCell>
            <TableCell white>{data.chargeUnit.win.mid}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell
              style={{
                borderTop: '0.5px solid #F4F5F8',
                borderBottomLeftRadius: '4px',
              }}
            />
            <TableCell>최대부하</TableCell>
            <TableCell white>{data.chargeUnit.spr.max}</TableCell>
            <TableCell white>{data.chargeUnit.sum.max}</TableCell>
            <TableCell white style={{ borderBottomRightRadius: '4px' }}>
              {data.chargeUnit.win.max}
            </TableCell>
          </TableRow>
        </Table>
      </TableWrapper>
    </LabelTable>
  )
}
